import { render, staticRenderFns } from "./shipmentData.vue?vue&type=template&id=2694de22&scoped=true"
import script from "./shipmentData.vue?vue&type=script&lang=js"
export * from "./shipmentData.vue?vue&type=script&lang=js"
import style0 from "./shipmentData.vue?vue&type=style&index=0&id=2694de22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2694de22",
  null
  
)

export default component.exports